import {
  changeTimeMembersTeam,
  CreatePersonalization,
  EditEmail,
  EditSettingPassword,
  GetPersonalization,
  HttpRequest,
  RequestMethod
} from '@/api';
import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  CREATE_PERSONALIZATION,
  EDIT_EMAIL,
  GET_PERSONALIZATION,
  MY_JOIN_TEAMS,
  SETTING_CHANGE_PASSWORD
} from './../../action-type/index';

interface HttpResponse<T> {
  status: number;
  result: T;
  message: string;
  success: boolean;
}

export const createPersonalization = createAsyncThunk(CREATE_PERSONALIZATION, async (payload: any) => {
  const response = (await HttpRequest({
    url: CreatePersonalization,
    method: RequestMethod.POST,
    body: payload
  })) as HttpResponse<any>;

  return response;
});

export const editEmail = createAsyncThunk(EDIT_EMAIL, async (payload: any) => {
  const response = (await HttpRequest({
    url: EditEmail,
    method: RequestMethod.PUT,
    body: payload
  })) as HttpResponse<any>;

  return response;
});

export const changeSettingPassword = createAsyncThunk(SETTING_CHANGE_PASSWORD, async (payload: any) => {
  const response = (await HttpRequest({
    url: EditSettingPassword,
    method: RequestMethod.POST,
    body: payload
  })) as HttpResponse<any>;

  return response;
});

export const changeMemberTime = createAsyncThunk(MY_JOIN_TEAMS, async (payload: any) => {
  const response = (await HttpRequest({
    url: changeTimeMembersTeam,
    method: RequestMethod.POST,
    body: payload
  })) as HttpResponse<any>;

  return response;
});
